import {GridColumn, GridColumnGroupDef} from "@data/interefaces/data.interfaces";
import {
  CircleCheckColumnComponent
} from "@pages/segments/grid/columns/circle-check-column/circle-check-column.component";
import {Util} from "@data/util/util";
import {SelectColumnComponent} from "@pages/segments/grid/columns/select-column/select-column.component";


export let displayTableColumns: (GridColumn | GridColumnGroupDef)[] = [
  {
    field: 'login',
    headerName: 'Login',
    pinned: "left",
    minWidth: 200,
    cellRenderer: SelectColumnComponent,
    cellRendererParams: function (params: any) {
      return {
        showFlag: params.data.processingNote != undefined,
        flagIcon: "fa-square-exclamation",
        flagColor: "red",
        toolTip: params.data.processingNote
      }
    }
  },
  {
    valueGetter: (params) => params.data ? `${params.data.email} (${params.data.firstName} ${params.data.lastName})` : '',
    headerName: 'Email',
    pinned: "left",
    minWidth: 300,
  },
  {
    field: 'accountType',
    headerName: 'Account Type',
  },
  {
    field: 'groupUser',
    headerName: 'Group User',
    cellRenderer: CircleCheckColumnComponent,
    cellRendererParams: function (params: any) {
      return {
        iconSize: 'fa-xl'
      };
    },
  },
  {
    field: 'testUser',
    headerName: 'Test User',
    cellRenderer: CircleCheckColumnComponent,
    cellRendererParams: function (params: any) {
      return {
        iconSize: 'fa-xl'
      };
    },
  },
  {
    field: 'oktaState',
    headerName: 'Okta State',
  },
  {
    field: 'oktaCreatedTimestamp',
    headerName: 'Okta Creation Date',
    valueFormatter: (params) => {
      return Util.getFormattedDate(params.value);
    },
  },
  {
    field: 'hasTableauLicense',
    headerName: 'Has Tableau License',
    cellRenderer: CircleCheckColumnComponent,
    cellRendererParams: function (params: any) {
      return {
        iconSize: 'fa-xl'
      };
    },
  },
  {
    field: 'tableauLicenseIsPermanent',
    headerName: 'Is Tableau Permanent',
    cellRenderer: CircleCheckColumnComponent,
    cellRendererParams: function (params: any) {
      return {
        iconSize: 'fa-xl'
      };
    },
  },
  {
    field: 'tableauLicenseExpiryDatetime',
    headerName: 'Tableau License Expiry Date',
    valueFormatter: (params) => {
      return Util.getFormattedDate(params.value);
    },
  },
  {
    field: 'tableauActivationDatetime',
    headerName: 'Tableau License Activation Date',
    valueFormatter: (params) => {
      return Util.getFormattedDate(params.value);
    },
  },
  {
    field: 'tableauDeactivationDatetime',
    headerName: 'Tableau License Deactivation Date',
    valueFormatter: (params) => {
      return Util.getFormattedDate(params.value);
    },
  },
];
